import React from "react";
import { Table } from "react-bootstrap";
import { FixedSizeList } from "react-window";

const DynamicTable = (props) => {
  const tableHeight = props.height || 400;
  const rowHeight = props.rowHeight || 60;

  const renderRows = ({ index, data, style }) => {
    const row = data.list[index - 1];
    return (
      <>
        {index === 0 ? (
          <th
            className="d-flex text-center align-items-center"
            style={{ ...style, backgroundColor: "#f2f2f2", fontWeight: "bold", padding: "0 20px" }}
          >
            {props.header}
          </th>
        ) : (
          <tr
            className={"d-flex text-center align-items-center"}
            style={{
              ...style,
              borderTop: "none",
              borderBottom: "1px solid #dbdbdb",
              backgroundColor: "#f2f2f2",
              padding: "0 20px",
            }}
            key={"table-row-" + index}
          >
            {row}
          </tr>
        )}
      </>
    );
  };

  return (
    <Table id="data" className="rounded">
      <FixedSizeList
        height={Math.min(tableHeight, (props.rows.length + 1) * rowHeight + 1)} // first plus 1 is to account for header. second + 1 prevents scroll bar from showing
        width={"100%"}
        itemSize={rowHeight}
        itemCount={props.rows.length + 1}
        itemData={{
          list: props.rows,
        }}
        className="rounded"
      >
        {renderRows}
      </FixedSizeList>
    </Table>
  );
};
export default DynamicTable;
